module.exports = __webpack_public_path__ + "img/network-err.1fa911c5.svg";